import React from 'react'
import { Empty, Spin } from 'antd'
import { isEmpty } from 'underscore'
import { ChartBox } from '../../../../ResultPanel/component/ChartBox'
import styles from '../../Layout/AnalyticsLayout.module.scss'
import ErrorDisplay from "../../ErrorDisplay";

interface StatisticsChartProps {
  statisticsImages: string
  statisticsValuesLinks: string[]
  pointName: string
  isLoading: boolean
  error: string
  isOfflineDataset: boolean
}

export default function StatisticsChart({
    statisticsImages,
    statisticsValuesLinks,
    isOfflineDataset,
    isLoading,
    error
  }: StatisticsChartProps) {
  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        minHeight: '400px'
      }}>
        <Spin size="large" />
      </div>
    )
  }

  if (isOfflineDataset) {
    return (
      <ErrorDisplay isOfflineDataset={isOfflineDataset}/>
    )
  }
  return (
    <div id="Analytics-Statistics-Plot" className={styles.chartPointWrapper}>
      <ChartBox
        key="Statistics"
        title="Statistics"
        height={isLoading || !isEmpty(error) ? '50px' : 'auto'}
        plot={
          isLoading ? (
            <div className={styles.spinner}>
              <Spin size="large" />
            </div>
          ) : !isEmpty(error) && !error.includes('Cmems error') ? (
            <div>{error}</div>
          ) : statisticsImages ? (
            <img
              style={{
                width: '80%',
                objectFit: 'scale-down',
                maxHeight: '65vh',
                display: 'block',
                margin: '0 auto'
              }}
              src={statisticsImages}
              alt="Statistics"
            />
          ) : <Empty description={error.includes('Cmems error') ? "Layer not available" : "No data available"} />
        }
        dataset=""
        showDisclaimer={statisticsImages ? true : false}
        link={statisticsValuesLinks}
      />
    </div>
  )
}
